document.addEventListener("DOMContentLoaded", function () {
  const countdownElement = document.querySelector(".header__timer");
  const timeWrapper = document.querySelector(".header__timer-wrapper");

  if (!countdownElement) return;

  const mode = countdownElement.dataset.mode || "hours";

  if (mode === "date") {
    // — Fixed end date mode —
    const endTimeStr = countdownElement.dataset.endDate;
    if (!endTimeStr) return;

    const endTime = new Date(endTimeStr).getTime();

    const updateTimer = () => {
      const now = Date.now();
      let diff = Math.floor((endTime - now) / 1000);

      if (diff <= 0) {
        diff = 0;
        if (timeWrapper) timeWrapper.style.display = "none";
      }

      setSplitDigits("countdown-days",    Math.floor(diff / 86400));
      setSplitDigits("countdown-hours",   Math.floor((diff % 86400) / 3600));
      setSplitDigits("countdown-minutes", Math.floor((diff % 3600) / 60));
      setSplitDigits("countdown-seconds", diff % 60);
    };

    updateTimer();
    setInterval(updateTimer, 1000);

  } else {
    // — Recurring hours mode —
    const COUNTDOWN_HOURS = parseFloat(countdownElement.dataset.hours) || 24;
    const STORAGE_KEY = "countdown_end_time_" + COUNTDOWN_HOURS;
    const DURATION_MS = COUNTDOWN_HOURS * 60 * 60 * 1000;

    const getEndTime = () => {
      const stored = localStorage.getItem(STORAGE_KEY);
      const now = Date.now();

      if (stored) {
        const endTime = parseInt(stored, 10);
        if (endTime > now) return endTime;
      }

      const newEndTime = now + DURATION_MS;
      localStorage.setItem(STORAGE_KEY, newEndTime);
      return newEndTime;
    };

    const updateTimer = () => {
      const now = Date.now();
      const endTime = getEndTime();
      let diff = Math.floor((endTime - now) / 1000);

      if (diff <= 0) {
        localStorage.removeItem(STORAGE_KEY);
        diff = Math.floor(DURATION_MS / 1000);
      }

      setSplitDigits("countdown-days",    Math.floor(diff / 86400));
      setSplitDigits("countdown-hours",   Math.floor((diff % 86400) / 3600));
      setSplitDigits("countdown-minutes", Math.floor((diff % 3600) / 60));
      setSplitDigits("countdown-seconds", diff % 60);
    };

    if (timeWrapper) timeWrapper.style.display = "";

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  function setSplitDigits(id, value) {
    const el = document.getElementById(id);
    if (!el) return;
    el.textContent = value.toString().padStart(2, "0");
  }
});